/* eslint-disable import/no-named-as-default */
import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import SubNavigation from "./SubNavigation";
// TODO_remove_stripe: This goes when we remove the last of the Stripe integration
// import Monthly from "./Monthly";
import Annually from "./Annually";
import Wrapper from "./styles/subscriptions-styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Subscriptions = () => (
  <Wrapper>
    <Router>
      <SubNavigation />
      <Switch>
        <Route exact path="/" component={Annually} />
        {/* TODO_remove_stripe: This goes when we remove the last of the Stripe integration */}
        {/*<Route exact path="/monthly" component={Monthly} />*/}
      </Switch>
    </Router>
  </Wrapper>
);

export default Subscriptions;
